export default function dropdown() {

    const openDropdownAction = document.querySelectorAll('.js-open-dropdown');
    openDropdownAction.forEach(btn => {
        const dropdown = btn.querySelector('.dropdown');
        btn.addEventListener('click', (e) => {
            dropdown.classList.toggle('open');
            btn.classList.toggle('active');


        })
        document.addEventListener('click', (e) => {
            if (!btn.contains(e.target)) {
                dropdown.classList.remove('open');
                btn.classList.remove('active');

            }
        });
    })

}